// src/App.js

import React, { lazy } from "react";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import LandingPage from "./Pages/LandingPage/LandingPage";
import SignUpPage from "./Pages/SignUp";
// import NavBar from "./Components/NavBar/NavBar"; // Import the NavBar component
import CompaniesPage from "./Pages/CompaniesPage";
import LibraryHub from "./Components/Library/LibraryHub";
import LoginPage from "./Pages/LoginPage";
import WithNavigationBar from "./Components/Navigation/WithNavigationBar";
import WithoutNavigationBar from "./Components/Navigation/WithoutNavigationBar";
import MyListings from "./Pages/MyBiz/MyListings/MyListings";
import { Button } from "@mui/material";
import WithSidebarAndNavigationBar from "./Components/Navigation/WithSidebarAndNavigationBar";
import PlaceholderPage from "./Pages/MyBiz/PlaceholderPage";
import MyConnections from "./Pages/MyBiz/MyConnections";
import MyInventory from "./Pages/MyBiz/MyInventory/MyInventory";
import BrowseListingsPage from "./Pages/BrowseListingsPage/BrowseListingsPage";
import ListingDetailsPage from "./Pages/ListingDetailsPage/ListingDetailsPage";
import MyPurchaseHistory from "./Pages/MyBiz/MyPurchaseHistory/MyPurchaseHistory";
import MyOrders from "./Pages/MyBiz/MyOrders/MyOrders";
import CartPage from "./Pages/CartPage";
import AboutUsPage from "./Pages/AboutUs";
import ContactUsPage from "./Pages/ContactUs";
import VerifyEmail from "./Pages/VerifyEmail";

const InputsPage = lazy(() => import("./Components/Library/InputsPage"));
const NavigationPage = lazy(
  () => import("./Components/Library/NavigationPage"),
);
const LayoutPage = lazy(() => import("./Components/Library/LayoutPage"));
const SurfacesPage = lazy(() => import("./Components/Library/SurfacesPage"));
const FeedbackPage = lazy(() => import("./Components/Library/FeedbackPage"));
const DataDisplayPage = lazy(
  () => import("./Components/Library/DataDisplayPage"),
);
const UtilsPage = lazy(() => import("./Components/Library/UtilsPage"));

// const emptyImage1 = require("./assets/images/Empty1.png");
// const emptyImage2 = require("./assets/images/Empty2.png");
// const emptyImage3 = require("./assets/images/Empty3.png");

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="bottom-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        toastClassName={() =>
          "custom-toast"
        }
      />
      <BrowserRouter>
        <div className="content">
          <Routes>
            {/* Routes with Navigation Bar */}
            <Route element={<WithNavigationBar />}>
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/" element={<LandingPage />} />
              <Route path="/browse" element={<BrowseListingsPage />} />
              <Route path="/listing/:listingId" element={<ListingDetailsPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path='/about' element={<AboutUsPage />} />
              <Route path='/contact' element={<ContactUsPage />} />
              <Route path='/verify-email' element={<VerifyEmail />} />

            </Route>

            {/* Routes with Top Navigation Bar and Sidebar Navigation */}
            <Route element={<WithSidebarAndNavigationBar />}>
              <Route path="/my-biz/my-listings" element={<MyListings />} />
              <Route
                path="/my-biz/my-inventory"
                element={<MyInventory />}
              />
              <Route
                path="/my-biz/orders"
                element={
                  <MyOrders />
                }
              />
              <Route
                path="/my-biz/purchases"
                element={
                  <MyPurchaseHistory />
                }
              />
              <Route
                path="/my-biz/inbox"
                element={
                  <PlaceholderPage
                    title="Inbox"
                    emptyStateText="Your inbox is empty."
                    emptyStateImage="/path/to/image.png"
                    actionButtons={
                      <Button variant="contained" color="primary">
                        Check Messages
                      </Button>
                    }
                  />
                }
              />
              <Route
                path="/my-biz/my-connections"
                element={
                  <MyConnections />
                }
              />
              <Route
                path="/my-biz/settings"
                element={
                  <PlaceholderPage
                    title="Settings"
                    emptyStateText="Adjust your settings here."
                    emptyStateImage="/path/to/image.png"
                    actionButtons={
                      <Button variant="contained" color="primary">
                        Change Settings
                      </Button>
                    }
                  />
                }
              />
            </Route>

            {/* Routes without Navigation Bar */}
            <Route element={<WithoutNavigationBar />}>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              {/* Add other routes as needed */}
            </Route>

            <Route path="/library" element={<LibraryHub />} />
            <Route path="/library/inputs" element={<InputsPage />} />
            <Route path="/library/navigation" element={<NavigationPage />} />
            <Route path="/library/layout" element={<LayoutPage />} />
            <Route path="/library/surfaces" element={<SurfacesPage />} />
            <Route path="/library/feedback" element={<FeedbackPage />} />
            <Route path="/library/data-display" element={<DataDisplayPage />} />
            <Route path="/library/utils" element={<UtilsPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
